export function evidenceIso(value) {
  if (value == null || value === '') return null;
  const seconds = value && typeof value === 'object' ? (value.seconds ?? value._seconds) : undefined;
  const raw = seconds != null ? Number(seconds) * 1000 : value;
  const date = new Date(raw);
  return Number.isNaN(date.getTime()) ? null : date.toISOString();
}

export function formatEvidenceTime(value) {
  const iso = evidenceIso(value);
  if (!iso) return 'Not recorded';
  return new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Chicago', year: 'numeric', month: 'short', day: 'numeric',
    hour: 'numeric', minute: '2-digit', second: '2-digit', timeZoneName: 'longOffset',
  }).format(new Date(iso)) + ' · America/Chicago';
}

// A server response replaces cached evidence as one record. Never combine a
// prior approval with a newer upload, rejection, deletion, or empty timestamp.
export function serverDocumentState(source = {}) {
  return {
    ...source,
    status: String(source.status || 'missing'),
    fileName: String(source.fileName || ''),
    uploadedAt: evidenceIso(source.uploadedAt),
    reviewedAt: evidenceIso(source.reviewedAt),
    uploadedByEmail: String(source.uploadedByEmail || ''),
    reviewedByEmail: String(source.reviewedByEmail || ''),
    expiresOn: String(source.expiresOn || ''),
    note: String(source.note || ''),
  };
}

export function completionMessage(assignment = {}, certificates = []) {
  if (assignment.state === 'waived') return 'Training requirement waived. No assessment certificate is implied.';
  if (assignment.state !== 'completed') return 'Answers are graded by the compliance service. The answer key is never sent to this browser.';
  if (certificates.some(item => item.certificateId === assignment.certificateId && item.assignmentId === assignment.assignmentId)) {
    return 'Completion and the linked certificate are recorded.';
  }
  if (assignment.completionSource === 'legacy_import') return 'Completion imported from the previous training system. No certificate is available in this workspace.';
  return 'Completion is recorded. A matching certificate is not available; contact ChemCab for review.';
}
